import { Link } from './link';
import { UserLinks } from './user';

type BBTeam = {
  account_id?: string;
  created_on?: string;
  display_name: string;
  extra?: {
    has_atlassian_account?: boolean;
    has_ssh_key?: boolean;
    search_state: 'ENABLED' | 'DISABLED';
    has_premium?: boolean | undefined;
    admin_status?: 'admin' | 'collaborator';
  };
  location?: string | null;
  links: UserLinks & {
    members?: Link;
    projects?: Link;
  };
  slug?: string;
  type: 'team';
  username: string;
  uuid: string;
  website?: string;
};

declare global {
  namespace BB {
    type Team = BBTeam;
  }
}

export type Team = BBTeam;
